import { Link } from 'react-router';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className='flex h-screen flex-col items-center justify-center gap-4'>
      <h1 className='text-2xl font-semibold'>Page not found</h1>
      <p className='text-sm text-muted-foreground'>
        The page you were looking for doesn&apos;t exist.
      </p>
      <Button asChild>
        <Link to='/accounts'>Back to Accounts</Link>
      </Button>
    </div>
  );
}
